import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.layout-shell {
  --layout-white-zone: 520px;
  position: relative;
  min-height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff var(--layout-white-zone), #f7f7f5 calc(var(--layout-white-zone) + 110px), #eceeed calc(var(--layout-white-zone) + 300px), #e5e8e7 100%);
  color: #09090b;
}

.layout-shell::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(circle at 16% calc(var(--layout-white-zone) + 320px), rgba(186, 194, 188, 0.16), transparent 24%), radial-gradient(circle at 82% calc(var(--layout-white-zone) + 240px), rgba(189, 198, 207, 0.16), transparent 22%);
}

.layout-header {
  border-bottom: 0;
  background: #ffffff;
  backdrop-filter: none;
  box-shadow: none;
}

.layout-header__inner,
.layout-main {
  position: relative;
  z-index: 1;
}

.layout-main {
  background: #ffffff;
}

.layout-menu-trigger {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  color: #0f172a;
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.layout-menu-trigger:hover {
  opacity: 0.62;
  transform: translateY(-1px);
}

.layout-menu-trigger:focus-visible {
  outline: 2px solid rgba(15, 23, 42, 0.18);
  outline-offset: 6px;
  border-radius: 14px;
}

.layout-header__nav a,
.layout-header__actions a {
  font-family: "Nanum Myeongjo", "Nanum Gothic", "Malgun Gothic", "Apple SD Gothic Neo", serif;
  letter-spacing: -0.01em;
}

.layout-header__nav a {
  font-weight: 700;
}

.layout-header__actions a {
  font-weight: 700;
}

@media (max-width: 640px) {
  .layout-shell {
    --layout-white-zone: 400px;
  }
  .layout-header {
    box-shadow: none;
  }
  .layout-menu-trigger {
    width: 40px;
    height: 40px;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(link: string) {
        const pathname = location.pathname;
        if (link === '/docs') {
            return pathname === '/docs' || (pathname.startsWith('/docs/') && pathname.startsWith('/docs/history') === false);
        }
        return pathname === link || pathname.startsWith(`${link}/`);
    }

    public headerLinkClass(link: string) {
        if (this.isActive(link)) {
            return 'relative whitespace-nowrap text-[15px] font-semibold text-zinc-950 after:absolute after:-bottom-2 after:left-0 after:h-[2px] after:w-full after:bg-zinc-950';
        }
        return 'relative whitespace-nowrap text-[15px] font-semibold text-zinc-500 transition hover:text-zinc-950 after:absolute after:-bottom-2 after:left-0 after:h-[2px] after:w-full after:origin-left after:scale-x-0 after:bg-zinc-950 after:transition-transform hover:after:scale-x-100';
    }

    public async toggleMenu(event?: Event) {
        event?.stopPropagation();
        await this.service.status.toggle('navbar');
    }

    public async closeMenu(event?: Event) {
        event?.stopPropagation();
        await this.service.status.hide('navbar');
    }

    public async transitionTo(path: string, external: boolean = false, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        if (this.service.status.headerTransition) return;
        if (!external && location.pathname === path) {
            await this.closeMenu();
            return;
        }

        await this.closeMenu();
        await this.service.status.show('headerTransition');

        window.setTimeout(async () => {
            if (external) {
                location.href = path;
                return;
            }

            await this.router.navigateByUrl(path);
            window.setTimeout(async () => {
                await this.service.status.hide('headerTransition');
            }, 420);
        }, 260);
    }
}

export default LayoutSidebarComponent;